import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from "react-redux";
import 'react-bootstrap';

import $ from "jquery/dist/jquery.js";
import blogApi from "../../../api/blogApi";
import SingleSlider from '../../../components/SingleSlider';
import { Businesses } from '../../../config/Helper';
import { lang } from '../../../config/lang';
import { setTimeout } from 'timers';
import * as UTILS from '../../../config/utils';

class BlogMain extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            blog: {media:[]}
        }

        this.id = this.props.id;
        this.business = this.props.business;
        this.lang = '';
        this.changeBlog = true;
        this.hidePreloader = this.hidePreloader.bind(this);
        this.getBlog = this.getBlog.bind(this);
    }

    componentWillMount() { 
        
    }

    componentDidMount() {
        this.showFooter(false);
        this.getBlog();
    }
  
    componentWillUnmount() {
        
    }
  
    componentWillReceiveProps(newProps) {
        if (this.lang !== newProps.language.lang_key
                        || this.business !== newProps.business
                        || this.id !== newProps.id ) {
            
            if (this.business !== newProps.business || this.id !== newProps.id) {
                this.changeBlog = true;
            } else {
                this.changeBlog = false;
            }

            this.lang       = newProps.language.lang_key;
            this.id         = newProps.id;
            this.business   = newProps.business;

            var slider = document.getElementById('single_slider');
            if (slider !== undefined && slider !== null && this.changeBlog === true) {
                ReactDOM.unmountComponentAtNode(document.getElementById('single_slider_container'));
            }
            
            this.getBlog();
        }
    }
    
    showFooter(willShow) {
        $('#footer').css("visibility", willShow ? "visible" : "hidden") ;
    }

    showPreloader() {
        if(this.refs.preloader) {
            ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "visible";  
        }
    }

    hidePreloader() {   
        if(this.refs.preloader) {
            ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "hidden";
        }
        this.showFooter(true);
    }

    getBlog() {
        if (this.changeBlog === true) {
            this.showPreloader();
        }

        blogApi.getBlog(Businesses[this.business], this.id).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    blog: json.data
                })
                
                window.contentWayPoint();
                if (this.changeBlog === true) {
                    ReactDOM.render(<SingleSlider 
                            media={this.state.blog.media} 
                            business={this.business} 
                            id={this.id} 
                            title={this.state.blog.title}/>, 
                        document.getElementById('single_slider_container'));
                    setTimeout(this.hidePreloader, 800);
                }
                
            } else {
                if (json.status === 200 && (json.data === "" || Businesses[this.business] === undefined)) {
                    this.setState({
                        blog: ""
                    })
                    setTimeout(this.hidePreloader, 0);
                } else {
                    
                }
            }            
        })
    }

    getAuthor(authorAndCountry) {
        if (authorAndCountry === null || authorAndCountry === undefined || authorAndCountry === "") {
            return "";
        }        
        var a = authorAndCountry.split(", ");
        if (a.length < 2) {
            return "";
        }

        if (a[0] === undefined || a[0] === null || a[0] === "") {
            return lang('author_from').replace('%country', a[1]);
        }

        if (a[1] === undefined || a[1] === null || a[1] === "") {
            return a[0];
        }
        return a[0] + ", " + lang('author_from').replace('%country', a[1]);
    }

    render() {
        
        if (this.state.blog === "") {
            return (
                <div className="row">
                    <h4>{lang('no_data')}</h4>
                </div>        
            );
        }

        const { blog: { style } } = this.state;
        if (style === undefined || style === 2) {
            return (
                <div className="row">
                    <div className="col-md-12">                                                          
                        <div id="single_slider_container">
                            {/* <SingleSlider 
                                media={this.state.blog.media} 
                                business={this.business}
                                id={this.id}
                            /> */}
                        </div>
                        <div className="preloader" ref="preloader">
                            <div className="spinner"></div>
                        </div>  
                        <p style={{fontStyle: 'italic', textIndent: this.lang === 'cn' ? '21.25pt' : '14.5pt'}}>- {lang(Businesses[this.business])}</p>
                        <div className="title ftco-animate" style={{textAlign: "center"}}
                            dangerouslySetInnerHTML={{__html: this.state.blog.title === undefined || this.state.blog.title === null ? '' : this.state.blog.title}}/>
                        {
                            Businesses[this.state.blog.business] === 'news' && 
                            <div className="testimonial-author text-right">                                                    
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }                                            
                        {
                            Businesses[this.state.blog.business] === 'experience' && 
                            <div className="testimonial-author text-right">
                                <p style={{marginBottom: "0.5rem"}}>{this.getAuthor(this.state.blog.others)}</p>
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }
                        {
                            Businesses[this.state.blog.business] === 'agency_news' && 
                            <div className="testimonial-author text-right">    
                                <p>{this.state.blog.agency}</p>
                            </div>
                        }
                        <div className="description ftco-animate" 
                            dangerouslySetInnerHTML={{__html: this.state.blog.description === undefined || this.state.blog.description === null ? '' : this.state.blog.description }}/>
                    </div>
                </div>
            );
        } else if (style === 0) {
            return (
                <div className="row">
                    <div className="col-md-12">   
                        <p style={{fontStyle: 'italic', textIndent: this.lang === 'cn' ? '21.25pt' : '14.5pt'}}>- {lang(Businesses[this.business])}</p>
                        <div className="title ftco-animate" style={{textAlign: "center"}}
                            dangerouslySetInnerHTML={{__html: this.state.blog.title === undefined || this.state.blog.title === null ? '' : this.state.blog.title}}/>
                        {
                            Businesses[this.state.blog.business] === 'news' && 
                            <div className="testimonial-author text-right">                                                    
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }                                            
                        {
                            Businesses[this.state.blog.business] === 'experience' && 
                            <div className="testimonial-author text-right">
                                <p style={{marginBottom: "0.5rem"}}>{this.getAuthor(this.state.blog.others)}</p>
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }
                        {
                            Businesses[this.state.blog.business] === 'agency_news' && 
                            <div className="testimonial-author text-right">    
                                <p>{this.state.blog.agency}</p>
                            </div>
                        }                                                       
                        <div className="mt-4" id="single_slider_container">
                            {/* <SingleSlider 
                                media={this.state.blog.media} 
                                business={this.business}
                                id={this.id}
                            /> */}
                        </div>
                        <div className="preloader" ref="preloader">
                            <div className="spinner"></div>
                        </div>  
                        
                        <div className="description ftco-animate" 
                            dangerouslySetInnerHTML={{__html: this.state.blog.description === undefined || this.state.blog.description === null ? '' : this.state.blog.description }}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row">
                    <div className="col-md-12">                                                          
                        
                        <p style={{fontStyle: 'italic', textIndent: this.lang === 'cn' ? '21.25pt' : '14.5pt'}}>- {lang(Businesses[this.business])}</p>
                        <div className="title ftco-animate" style={{textAlign: "center"}}
                            dangerouslySetInnerHTML={{__html: this.state.blog.title === undefined || this.state.blog.title === null ? '' : this.state.blog.title}}/>
                        {
                            Businesses[this.state.blog.business] === 'news' && 
                            <div className="testimonial-author text-right">                                                    
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }                                            
                        {
                            Businesses[this.state.blog.business] === 'experience' && 
                            <div className="testimonial-author text-right">
                                <p style={{marginBottom: "0.5rem"}}>{this.getAuthor(this.state.blog.others)}</p>
                                {/* <p>{UTILS.getDateString(this.state.blog.created_at)}</p> */}
                            </div>
                        }
                        {
                            Businesses[this.state.blog.business] === 'agency_news' && 
                            <div className="testimonial-author text-right">    
                                <p>{this.state.blog.agency}</p>
                            </div>
                        }
                        <div className="description ftco-animate" 
                            dangerouslySetInnerHTML={{__html: this.state.blog.description === undefined || this.state.blog.description === null ? '' : this.state.blog.description }}/>
                        <div className="mt-5" id="single_slider_container">
                            {/* <SingleSlider 
                                media={this.state.blog.media} 
                                business={this.business}
                                id={this.id}
                            /> */}
                        </div>
                        <div className="preloader" ref="preloader">
                            <div className="spinner"></div>
                        </div>  
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(BlogMain);